import { IndexRoute, Route, Redirect } from 'react-router'
import {
  FaqContainer,
  AppContainer,
  TutorialsContainer,
  LoginContainer,
  HomeContainer,
  GuideContainer,
  FaqListContainer,
  TutorialListContainer,
  Osearch,
  NotesWindow,
  ESSearch
} from '../containers'
import { getName } from '../store'

/**
 * Functions for getting the name of a route.
 * @todo unused
 * @see {@link https://github.com/devicebits/selfservice-web/blob/master/src/routes/Routes.jsx getName}
 */
const getHomeName = getName.bind(null, 'home')
const getGuidesName = getName.bind(null, 'guides')
const getFaqsName = getName.bind(null, 'faqs')
const getTutorialsName = getName.bind(null, 'tutorials')
const getStartName = getName.bind(null, 'start')
const getSearchName = getName.bind(null, 'search')
const getNotesName = getName.bind(null, 'notes')
const getLoginName = getName.bind(null, 'login')

export const createRoutes = auth => (
  <Route path="/" auth={auth}>
    <Route path="login" component={LoginContainer} />
    <Route path="notes" component={NotesWindow} />
    <Route component={AppContainer} onEnter={auth.requireAuth}>
      <IndexRoute component={HomeContainer} />
      <Route path="guide/:id" component={GuideContainer} />
      <Route path="faqs" component={FaqListContainer} />
      <Route path="faq/:id" component={FaqContainer} />
      <Redirect from="faqs/:id" to="faq/:id" />
      <Route path="tutorials" component={TutorialListContainer} />
      <Route path="tutorial/:id" component={TutorialsContainer} />
      <Redirect from="tutorials/:id" to="tutorial/:id" />
      <Route path="search" component={ESSearch} />
      <Route path="v2/search" component={Osearch} />
    </Route>
  </Route>
)
